import { createContext, useContext, ReactNode } from 'react';

interface LayoutContextType {
  hasLayout: boolean;
}

const LayoutContext = createContext<LayoutContextType>({ hasLayout: false });

export const useLayout = () => useContext(LayoutContext);

interface LayoutProviderProps {
  children: ReactNode;
}

/**
 * LayoutProvider - Marks that layout (Sidebar/Header) is provided at this level
 * Used to prevent duplicate sidebar/header rendering when pages also include them
 */
export const LayoutProvider = ({ children }: LayoutProviderProps) => {
  return (
    <LayoutContext.Provider value={{ hasLayout: true }}>
      {children}
    </LayoutContext.Provider>
  );
};

export default LayoutContext;
